<template>
  <div class="hello">
      {{setupRefundAmount}}

    <!-- Modal to show refund error -->
    <b-modal no-fade id="modal-refundfailure" ok-only title="Serve Error" ok-title="OK" :hide-header="true" @ok="hideModal">
        There was an error refunding this payment. Please try again later. 
    </b-modal>
    <!-- Modal to show refund success -->
    <b-modal no-fade id="modal-refundsuccess" ok-only title="Refund Succedded" ok-title="OK" :hide-header="true" @ok="hideModal">
        The refund has been processed
    </b-modal>

    <b-container>
        <b-row>
            <b-col>
                <h6>Refund Amount (max = {{maxRefundAmount}})</h6>
            </b-col>
        </b-row>

        <!-- Amount -->
         <b-row>
            <b-col>
                <div v-if="inputError" style="color:red">Invalid refund amount</div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div v-if="maxRefundExceeded" style="color:red">Max refund is {{maxRefundAmount}}</div>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-form-input v-model="refundAmount" placeholder="Enter Amount"></b-form-input>
            </b-col>
        </b-row>

        <!-- Add tax only not issuing keg deposit refund -->
        <b-row class="mt-3" v-if="isRefundingDeposit!=1">
            <b-col>
                <b-form-checkbox :id='"checkbox-refundtax" + order.mainorder' v-model="addTaxes" name="checkbox-refundtax" :value=1 :unchecked-value=0>
                Add taxes to refund?</b-form-checkbox>
            </b-col>
        </b-row>

        <!-- Total refund -->
        <b-row class="mt-3">
            <b-col>
                <h5 style="color:green">Total Refund: ${{calculateTotalRefund}}</h5>
            </b-col>
        </b-row>

        <!-- Note -->
        <b-row class="mt-3">
            <b-col>
                <h6>Reason for refund (visible to customers)</h6>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-form-input v-model="refundNote" placeholder="Reason for refund"></b-form-input>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col>
                <b-button @click="startRefund()">Issue Refund</b-button>
            </b-col>
        </b-row>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import { SERVERADDRESS, stripeAPIToken } from '../Myfunctions'
const fb = require('../../firebaseConfig.js')

export default {    

    props: {
            order: { type: Object },
            closeModal:{ type: Function },
            isRefundingDeposit: {type : Number}
        },

    computed: {
        ...mapState([ 'userProfile', 'currentUser']),
        //Setup original refund amount from keg deposit
        setupRefundAmount(){
            //Calculate max refund based on what has already been refunded
            this.maxRefundAmount = parseFloat(this.order.totalCost)
            if ('refunds' in this.order){
                for (var i=0; i<this.order.refunds.length; i ++){
                    var thisRefund = this.order.refunds[i]
                    if ('totalrefund' in thisRefund){
                        this.maxRefundAmount = this.maxRefundAmount - parseFloat(thisRefund.baserefund)
                    } 
                }
            }

            //Check if keg deposit refund
            if (this.isRefundingDeposit==1){
                this.refundNote = "Keg Deposit Refund"
                this.refundAmount = this.order.kegDeposit
            } 
        },

        //Calculate refund with taxes
        calculateTotalRefund(){
            this.totalRefundAmount = this.refundAmount
            if(this.addTaxes==1){
                this.taxRefund = this.refundAmount*parseFloat(this.order.taxrate)
                this.totalRefundAmount = parseFloat(this.totalRefundAmount) + this.taxRefund 
            }
            return this.totalRefundAmount
        },
    },

    components: {
    },

    data() {
        return {
            refundAmount:0,
            addTaxes:0,
            taxRefund:0,
            totalRefundAmount:0,
            stripe: '',
            clientSecret:'',
            refundNote:'',
            addTax:0,
            taxRefund:0,
            totalRefundAmount:0,
            inputError:false,
            maxRefundAmount:0,
            maxRefundExceeded:false,
        }
    },

    methods:{
        //Get the key to start refund
        startRefund(){
            //Check if valid numbers have been entered
            if(isNaN(this.refundAmount)||this.refundAmount<=0){
                this.inputError = true
                return
            }
            else this.inputError = false

            //Check max refund exceeded
            if (this.refundAmount>this.maxRefundAmount){
                this.maxRefundExceeded = true
                return
            }
            else this.maxRefundExceeded=false

            console.log("Refunding " + this.refundAmount)
            console.log("Key = " + this.clientSecret)
            var paymentId = this.order.paymentIntentId
            console.log("Intent ID = " + paymentId)

            //Send to server to issue refund
            var bodyFormData = new FormData();
            bodyFormData.set('paymentid', paymentId);
            bodyFormData.set('amount', this.refundAmount);
            bodyFormData.set('currency', 'usd');

            axios({
                method: 'post',
                url: SERVERADDRESS+'/refund',
                data: bodyFormData,
                headers: {'Content-Type': 'multipart/form-data' }
            }).then(response => {
                console.log("Refunded")
                //Update database and add the refund
                //Get existing refunds
                var docRef = fb.consumerOrdersCollection.doc(this.order.docId);
                docRef.get().then(doc => {
                    if (doc.exists) {
                        var theOrder = doc.data()
                        var refunds = []
                        if ('refunds' in theOrder) refunds = theOrder.refunds
                        var newRefund = {date: new Date(), baserefund: this.refundAmount, taxrefund: this.taxRefund, totalrefund: this.totalRefundAmount, note:this.refundNote}
                        refunds.push(newRefund)
                        var theRefObject={refunds: refunds}
                        //Check if this was keg deposit
                        if(this.isRefundingDeposit==1) theRefObject.kegDepositRefunded=1
                        fb.consumerOrdersCollection.doc(this.order.docId).update(theRefObject)

                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });

                this.$bvModal.show("modal-refundsuccess")

            })
            .catch(response => {
                //handle server error
                this.serverError=true
                this.startingPayment=false
                this.$bvModal.show("modal-refundfailure")
                console.log(response);
                return "ERROR"
            });

        },
        //Configure Stripe
        configureStripe(){
            this.stripe = Stripe( stripeAPIToken );
        },

        //Setup Stripe
        includeStripe( URL, callback ){
            let documentTag = document, tag = 'script',
                object = documentTag.createElement(tag),
                scriptTag = documentTag.getElementsByTagName(tag)[0];
            object.src = '//' + URL;
            if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
            scriptTag.parentNode.insertBefore(object, scriptTag);
        },

        //Hide the modal on clicking OK after refund
        hideModal(){
            console.log("Hiding modal")
            this.closeModal(this.order)
        }
    },

    mounted(){
        this.includeStripe('js.stripe.com/v3/', function(){
            this.configureStripe();
            }.bind(this) );
    },
}
</script>

